import axios from 'axios';
import config from "../lib/config.js";
import { AppenData, EncryptData, axiosFunc, localGet, localSet } from '../lib/common.js';


export const loginAdmin = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/adminlogin`,
            // 'data': data

        }
        const resp = await axiosFunc(sendData, payload)
        if (resp.token)
            localSet("token", resp.token);

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }


}
export const getarticle = async () => {
    try {
        var resp = await axios({
            'method': 'GET',
            'url': `${config.AdminAPI}/getarticle`,
        })
        return resp.data;
    }
    catch (err) {
        //  console.log("err in article list", err)
         }
}

export const getaboutuser = async () => {
    try {
        var resp = await axios({
            'method': 'GET',
            'url': `${config.AdminAPI}/getaboutuser`,
        })
        return resp.data;
    }
    catch (err) { 
        // console.log("err in article list", err) 
    }
}

export const customtokenfetch = async (data) => {
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/tokenfetchapi`,
            // 'data': data

        }
        const resp = await axiosFunc(sendData, data)
        if (resp.data.token)
            localSet("token", resp.data.token);

        return resp.data;
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const check = async () => {

    try {
        var data = { "test": "testdata" }
        var resp = await axios({
            "method": "POST",
            'url': `${config.AdminAPI}/checkroute`,
            "data": data,
            "headers": {
                "Authorization": localGet("token")
            }
        })

    }
    catch (err) {
        //  console.log("err".err) 
        }

}


export const createProject = async (data) => {
    // const encData = AppenData(data)
    try {
        // var data = { "test": "testdata" }
        const sendData = {
            "method": "POST",
            'url': `${config.AdminAPI}/createProject`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)
        return resp

    }
    catch (err) { 
        // console.log("err",err) 
    }

}

export const getTokenCount = async (data) => {
    // const encData = EncryptData(data)
    try {
        // var data = { "test": "testdata" }
        const sendData = {
            "method": "get",
            'url': `${config.AdminAPI}/getTokenCount`,
            // "params": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const collectionFunctions = async (data) => {
    // const encData = AppenData(data)
    try {
        const sendData = {
            "method": "POST",
            'url': `${config.AdminAPI}/collectionFunctions`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const imgageupload = async (data) => {
    // const encData = AppenData(data)

    try {
        const sendData = {
            "method": "POST",
            'url': `${config.AdminAPI}/createNft`,
            // "data": data,
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err",err)
         }

}


export const editToken = async (data) => {
    // const encData = AppenData(data)

    try {
        const sendData = {
            "method": "POST",
            'url': `${config.AdminAPI}/editTokens`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const getNftsByProjectId = async (data) => {
    // const encData = AppenData(data)
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "GET",
            'url': `${config.AdminAPI}/getNftsByProjectId`,
            // "params": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const getKycList = async (data) => {
    // const encData = AppenData(data)
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "GET",
            'url': `${config.AdminAPI}/KycList`,
            // "params": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err)
        }

}


export const newsAndFeedFunc = async (data) => {
    // const encData = AppenData(data)
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "post",
            'url': `${config.AdminAPI}/newsAndFeed`,
            // "data": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const getblogCategories = async (data) => {
    // const encData = AppenData(data)
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "get",
            'url': `${config.AdminAPI}/blogCategories`,
            // "params": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const blogsFunction = async (data) => {
    // const encData = AppenData(data)
    // const encData = AppenData(data)
    try {
        const sendData = {
            "method": "post",
            'url': `${config.AdminAPI}/blogsFunction`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)

        return resp

    }
    catch (err) {
        //  console.log("err".err)
        }

}


export const saveCkeditorImage = async (data) => {
    // const encData = AppenData(data)
    try {
        const sendData= {
            "method": "post",
            "url": `${config.AdminAPI}/saveCkeditorImage`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)
        return resp
    }
    catch (err) {
        throw err
    }
}

export const stakingFunctions = async (data) => {
    // const encData = AppenData(data)
    try {
        const sendData = {
            "method": "post",
            "url": `${config.AdminAPI}/stakingFunctions`,
            // "data": encData[0],
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data, true)
        return resp
    }
    catch (err) {
        throw err
    }
}

//whitelist 
export const addwhitelists = async (data) => {
    // const encData = AppenData(data)
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "post",
            'url': `${config.AdminAPI}/addwhitelists`,
            // "data": { data: encData },
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, data)

        return resp

    }
    catch (err) {
        //  console.log("err".err) 
        }

}

export const hideShowwallet = async (data) => {
    // const encData = EncryptData(data)
    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/truefalseaddress`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": { data: encData },
        }
        var resp = await axiosFunc(sendData, data)

        return resp.data

    } catch (err) {
        // console.log("err in hide cat", err)
    }
}

export const createAdmin = async (payload) => {
    let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/createAdmin`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const getReportsFunc = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/getReportsFunc`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const getGasFees = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/gasManagerFunc`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const gasTokensFunctions = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/gasTokensFunctions`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const getSetting = async (payload) => {
    try {
        var resp = await axiosFunc({
            "method": "get",
            'url': `${config.AdminAPI}/getSettings`,
            "headers": {
                "Authorization": localGet("token")
            }
        })
        return resp
    }
    catch (err) { 
        // console.log("err".err) 
    }
}

export const kycSettingFunc = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/kycSettings`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)
        console.log("UserRestrictedresp",{resp, data:{
            'method': 'POST',
            'url': `${config.AdminAPI}/kycSettings`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }});

        return resp
    }
    catch (err) {
        // console.log("err", err)
    }
}

export const getEmailTemplates = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/getEmailTemplate`,
            // 'data': data,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)
        console.log(resp,"respresprespresp");

        return resp
    }
    catch (err) {
        console.log("err", err)
    }
}

export const getNotifications = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/listPromotionNotification`,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)
        console.log(resp,"respresprespresp");

        return resp
    }
    catch (err) {
        console.log("err", err)
    }
}

export const addNotifications = async (payload) => {
    // let data = { "data": EncryptData(payload) }
    try {
        const sendData = {
            'method': 'POST',
            'url': `${config.AdminAPI}/addPromotionNotification`,
            "headers": {
                "Authorization": localGet("token")
            },
        }
        const resp = await axiosFunc(sendData, payload)
        console.log(resp,"respresprespresp");

        return resp
    }
    catch (err) {
        console.log("err", err)
    }
}